
export enum FieldType
{
    Markdown = "Markdown",
    Text = "Text",
    Faq = "Faq",
    Table = "Table",
    Gallery = "Gallery",
    Opinion = "Opinion",
    TextWithPicture = "TextWithPicture"
}
